// External Dependencies:
import React from 'react'

class Waypoint extends React.Component {
	constructor() {
		super()

		this.ref = React.createRef()
		this.state = {
			inViewport: false
		}
	}

	componentDidMount() {
		const { rootMargin = '0px', threshold = 1 } = this.props

		const observer = new IntersectionObserver( this.handleObserve, {
			rootMargin,
			threshold
		} )

		observer.observe( this.ref.current )
	}

	handleObserve = ( entries, observer ) => {
		const { onEnter, onLeave, once, checkIntersectionRatio = true } = this.props
		const { inViewport } = this.state

		entries.forEach( entry => {
			if ( ! inViewport && entry.isIntersecting && ( ! checkIntersectionRatio || entry.intersectionRatio === 1 ) ) {
				this.setState( {
					inViewport: true
				} )

				if ( once ) {
					observer.unobserve( entry.target )
				}

				if ( onEnter ) {
					onEnter()
				}
			// } else if ( inViewport && ! entry.isIntersecting && entry.intersectionRatio === 0 ) {
			} else if ( inViewport ) {
				this.setState( {
					inViewport: false
				} )

				if ( onLeave ) {
					onLeave()
				}
			}
		} )
	}

	render() {
		let { style = {}, className = '' } = this.props
		const theStyle = { ...style, fontSize: 0 }
		className += ' waypoint'

		theStyle.fontSize = 0

		return (
			<span className={ className } ref={ this.ref } style={ theStyle }></span>
		)
	}
}

export default Waypoint


// WEBPACK FOOTER //
// ./components/Waypoint/Waypoint.jsx